/** @format */

import React from 'react'
import { Button } from 'kpc-react'

interface CloseFooterProps {
  text?: string
  onClose: () => void
}

const CloseFooter: React.FC<CloseFooterProps> = ({ text = '关闭', onClose }) => {
  return (
    <React.Fragment>
      <Button onClick={onClose}>{text}</Button>
    </React.Fragment>
  )
}

export default CloseFooter
